import React, { useCallback } from 'react'
import {
  DescWrapper,
  TitleDescContainer,
  TitleWrapper,
  ItemWrapper,
} from '~/app/components/Cart/CartGroup/CartGroup.style'
import DomesticBusItem from '~/app/components/Cart/CartItem/DomesticBusItem'
import { DomesticBusCartItem, DomesticBusCartItemOption } from '~/__generated__/__types__'

interface DomesticBusGroupProps {
  onCheck?: (checked: boolean, id: string) => void
  onClose?: (id: string) => void
  busCartItem: DomesticBusCartItem
  onTitleClick?: (id: string) => void
  onCancelRefreshButtonClick?: () => void
}

const DomesticBusGroup: React.FC<DomesticBusGroupProps> = ({
  onCheck,
  onClose,
  onTitleClick,
  busCartItem,
  onCancelRefreshButtonClick,
}) => {
  const onGroupTitleClick = useCallback(() => {
    onTitleClick?.(busCartItem.options?.[0]?.id)
  }, [busCartItem.options])
  return (
    <>
      <TitleDescContainer>
        <TitleWrapper onClick={onGroupTitleClick}>{busCartItem.representativeName}</TitleWrapper>
        <DescWrapper>{'교통'}</DescWrapper>
      </TitleDescContainer>
      {busCartItem.options.map((option: DomesticBusCartItemOption) => (
        <ItemWrapper key={option.id}>
          <DomesticBusItem
            option={option}
            onCheck={onCheck}
            onClose={onClose}
            onTitleClick={onTitleClick}
            onCancelRefreshButtonClick={onCancelRefreshButtonClick}
          />
        </ItemWrapper>
      ))}
    </>
  )
}

export default DomesticBusGroup
